<template>
  <div class="custom-select">
    <div class="custom-select__selected" :class="{ open: open }" @click.stop="open = !open">
      {{ value ? value : "viewer" }}
    </div>
    <div class="custom-select__arrow" :class="{ expanded: open }"></div>
    <div v-if="open" class="custom-select__items" :style="dropdownStyle">
      <div
        v-for="(option, i) of options"
        :key="i"
        class="custom-select__items--item"
        @click="
          open = false;
          $emit('input', option.value);
        "
      >
        <custom-icon :class-name="`${option.icon}`" />
        <span>{{ option.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import customIcon from "./CustomIcon.vue";

export default {
  components: { customIcon },
  props: ["options", "value"],
  emits: ["input"],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    dropdownStyle() {
      const itemHeight = 42; // Height of each item (including padding)
      const maxItems = 4; // Maximum number of items before showing scroll
      const itemCount = this.options.length;
      const height = Math.min(itemCount, maxItems) * itemHeight;

      return {
        height: `${height}px`,
        overflowY: itemCount > maxItems ? "auto" : "hidden",
      };
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.expanded {
  transform: rotateZ(180deg) translateY(2px);
}

.custom-select {
  position: relative;

  &__selected {
    border-bottom: thin solid @kk-color-black;
    color: @kk-color-black;
    cursor: pointer;
    user-select: none;
    font-size: 1rem;
  }

  &__arrow {
    position: absolute;
    right: 10px;
    top: 40%;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 8px solid @kk-color-gray;
    transition-duration: 0.3s;
  }

  &__items {
    position: absolute;
    background-color: @kk-color-white;
    color: @kk-color-dark;
    left: 0;
    right: 0;
    z-index: 105;
    box-shadow: @kk-select-box-shadow;
    border-radius: @kk-border-radius;

    &--item {
      height: 42px; // Fixed height for each item
      padding: 10px;
      cursor: pointer;
      user-select: none;
      display: flex;
      align-items: center;
      gap: 8px;

      &:hover {
        background-color: @kk-color-light-gray;
      }
    }
  }
}
</style>
